/* istanbul ignore file */
import { ProtectedRouter } from 'infrastructure/routing';
import { Routes } from 'react-router-dom';
import { Route } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import UnlinkedCrmActivitiesTimelinePage from 'domain/sales/unlinkedEmails/UnlinkedCrmActivitiesTimelinePage';
import { GlobalProtectedRoute } from 'framework/authorization';
import { READ_UNLINKED_CRM_ACTIVITY_PERMISSION } from 'domain/sales/unlinkedEmails/shared/unlinkedCrmActivitiesService';

const useUnlinkedCrmEmailActivitiesRoute = () => {
  return {
    unlinkedRoute: '/timeline/:timelineEntryId?',
  };
};

const UnlinkedCrmEmailActivitiesRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { unlinkedRoute } = useUnlinkedCrmEmailActivitiesRoute();

  return (
    <ProtectedRouter basePath="/crm/unlinked-activities/timeline">
      <Routes>
        <Route
          path={unlinkedRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_UNLINKED_CRM_ACTIVITY_PERMISSION}>
              <UnlinkedCrmActivitiesTimelinePage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

UnlinkedCrmEmailActivitiesRouter.getRouterPath = () => '/unlinked-activities/*';

export default UnlinkedCrmEmailActivitiesRouter;
